// extracted by mini-css-extract-plugin
export default {"text":"EditButton_text__tV38b"};